import { Column, ColumnFilterClearTemplateOptions, ColumnFilterElementTemplateOptions } from 'primereact/column';

import { TableComponent } from '../../../components/Table';
import { Filters } from './Filters';
import { IInventoryProvider } from '../../../interfaces/service/InventoryServiceManagerInterface';
import { createInventoryColumnsTable } from './table/helper';
import { InputText } from 'primereact/inputtext';

interface IInventoryTableProps {
  serviceInventory: IInventoryProvider;
}

export const InventaryTable = (props: IInventoryTableProps) => {
  const { serviceInventory } = props;

  const getColumnsToDisplayInTable = () => {
    const _columnsTable = createInventoryColumnsTable(serviceInventory);
    let columns = _columnsTable.map((column: any, index: number) => {
      const key = index.toString();
      return (
        <Column
          key={key}
          field={column.field}
          header={column.header}
          sortable={column.sortable}
          body={column.body}
          filter={column.filter}
          showFilterMenu={false}
          filterMenuStyle={{ minWidth: '18rem' }}
          bodyClassName="!text-grey !text-[12px]"
          headerClassName="!font-bold !justify-between !bg-white !text-grey"
          filterHeaderClassName="!text-black !justify-between !bg-white !h-8"
          style={{ flexGrow: 1, flexBasis: '100px' }}
          filterField={column.field}
          filterElement={(options: ColumnFilterElementTemplateOptions) => (
            <InputText
              value={options.value ?? ''}
              onChange={e => options.filterApplyCallback(e.target.value)}
              placeholder={`${column.header}`}
              className="p-inputtext-sm w-full !h-8 text-sm"
            />
          )}
          filterClear={(options) => {
              options.filterClearCallback();
              serviceInventory.setSelectedSam([]);
              return null;
            }}
        />
      );
    });

    columns.unshift(
      <Column
        selectionMode="multiple"
        bodyClassName="!text-black"
        headerClassName="!text-black !justify-between !bg-white"
        filterHeaderClassName="!text-black !justify-between !bg-white !h-8"
        style={{ flexGrow: 1, flexBasis: '100px' }}
        key="selection"
      />
    );

    return columns;
  };

  return (
    <div className="flex w-full h-full relative flex-col gap-y-2">
      <div className="flex w-full h-24">
        <Filters serviceInventory={serviceInventory} />
      </div>
      <div className="h-full flex flex-col w-full overflow-y-auto relative bg-white rounded-md shadow-lg p-4">
        <TableComponent
          value={serviceInventory.samListDataTemp}
          sortField="name"
          responsiveLayout="scroll"
          className="flex h-full w-full rounded relative"
          globalFilterFields={[
            'ActivatedOn',
            'AmountTransactionAdditional',
            'CreatedOn',
            'DeviceType',
            'KeyVersion',
            'LocationId',
            'LocationGpsObject',
            'Name',
            'NumberDevice',
            'Observations',
            'PcModules',
            'PointOfSale',
            'Project',
            'RouteName',
            'RouteNumber',
            'SamActivatedBy',
            'SamId',
            'SamType',
            'Station',
            'TechnologicalOperator',
            'TransportCompanyEUR',
          ]}
          resizableColumns={true}
          setSort={serviceInventory.setSort}
          sort={serviceInventory.sort}
          reorderableColumns={true}
          OnEmptyMessage="No se encontraron registros, seleccione algún filtro y presione el botón 'Enviar' para mostrar resultados"
          selectionMode={'checkbox'}
          selection={serviceInventory.selectedSam}
          loading={serviceInventory.loader}
          filters={serviceInventory.filters}
          filterDisplay="row"
          paginator={true}
          rowsPerPageOptions={true}
          onSelectionChange={(e: any) =>
            serviceInventory.setSelectedSam(e.value)
          }>
          {serviceInventory.samListDataTemp.length > 0
            ? getColumnsToDisplayInTable()
            : null}
        </TableComponent>
      </div>
    </div>
  );
};
